import { LOG_IN, LOG_OFF } from '../types';
import axios from 'axios';
axios.defaults.withCredentials = true;

export const logIn = (oUserData) => dispatch => {
  return dispatch({
    type: LOG_IN,
    payload: oUserData.data,
  });
}

export const logOut = () => dispatch => {
  return dispatch({
    type: LOG_OFF
  });
}


// WEBPACK FOOTER //
// ./src/store/actions/login/loginActions.js